import { useMemberExtract } from 'contexts/MemberExtract';
import React from 'react';
import EmptyState from './EmptyState';
import Table from './Table';

function Body() {
  const { isEmptyExtract } = useMemberExtract();

  return <div className="corporate-club-extract__card__body">{isEmptyExtract ? <EmptyState /> : <Table />}</div>;
}

export default Body;
